import * as Yup from 'yup';
import { shiftDemandFormModel } from './shiftDemandFormModel';

const {
  formField: { shiftTemplateId, positionId, date, requiredEmployees },
} = shiftDemandFormModel;

export default [
  Yup.object().shape({
    [shiftTemplateId.name]: Yup.object().nullable().required(shiftTemplateId.requiredErrorMsg),
    [positionId.name]: Yup.object().nullable().required(positionId.requiredErrorMsg),
    [date.name]: Yup.string().required(date.requiredErrorMsg),
    [requiredEmployees.name]: Yup.number()
      .typeError('Debe ser un número')
      .min(1, 'El mínimo es 1')
      .required(requiredEmployees.requiredErrorMsg),
  }),
];
